import React from "react";
import personal from "@/data/personal.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { prozess } = personal;

export const Prozess = () => (
  <Section id="ablauf" testId="personal-prozess" className="has-lines overflow-hidden bg-[#f5f6f4]">
    <FlowLines color="#0F9D6E" opacity={[0.055, 0.045]} />
    <Container>
      <Reveal>
        <Label>{prozess.label}</Label>
        <AccentH2 className="mt-6 max-w-[760px] font-bold text-[#1e2532]">{prozess.h2}</AccentH2>
        <p className="mt-6 max-w-[700px] text-[17px] leading-[1.8] text-[#565f70]">{prozess.intro}</p>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-7">
        {prozess.steps.map((s, i) => (
          <div
            key={s.num}
            data-testid={`prozess-step-${i}`}
            className="card-hover h-full rounded-[16px] border border-[#dfe2e0] bg-white p-7 md:p-8"
          >
            <span className="font-display text-[13px] font-bold tracking-[0.14em] text-[#0f9d6e]">{s.num}</span>
            <h3 className="mt-4 text-[18px] font-semibold leading-[1.35] text-[#1e2532]">{s.h3}</h3>
            <span className="accent-rule mt-4" aria-hidden="true" />
            <p className="mt-4 text-[15.5px] leading-[1.74] text-[#565f70]">{s.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </Section>
);
